export class RegisterWithEmail {
  constructor(authApiClient) {
    this.authApiClient = authApiClient;
  }

  execute(payload) {
    return this.authApiClient.register(payload);
  }
}

